// Main function to initialize collapsibles
function initCollapsibles() {
  const collapsibles = document.querySelectorAll(".cust__collap-item");

  collapsibles.forEach((item) => {
    // Skip if already initialized
    if (item.hasAttribute("data-collap-initialized")) {
      return;
    }

    const tab = item.querySelector(".cust__collap-tab");
    const content = item.querySelector(".cust__collap-content");
    const chevron = item.querySelector(".cust__collap-chevron");

    // Mark as initialized
    item.setAttribute("data-collap-initialized", "true");

    tab.addEventListener("click", function () {
      const isActive = content.classList.contains("is-active");

      if (!isActive) {
        tab.classList.add("is-active");
        content.classList.add("is-active");
        chevron.classList.add("is-active");
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        tab.classList.remove("is-active");
        content.classList.remove("is-active");
        chevron.classList.remove("is-active");
        content.style.maxHeight = "0";
      }
    });

    // Initialize open state if needed
    if (content.classList.contains("is-active")) {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}

// Initial load
document.addEventListener("DOMContentLoaded", initCollapsibles);

// For Shopify theme editor
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  // MutationObserver for dynamic content changes
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        initCollapsibles();
      }
    });
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Also listen for Shopify's section load event
  document.addEventListener("shopify:section:load", function (event) {
    const section = event.target;
    if (section.querySelector(".cust__collap-item")) {
      initCollapsibles();
    }
  });
}

// Handle window resize
window.addEventListener("resize", function () {
  document
    .querySelectorAll(".cust__collap-content.is-active")
    .forEach((content) => {
      content.style.maxHeight = content.scrollHeight + "px";
    });
});
